import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventTimePenalty extends DomainEvent<MatchEvent> {}
